import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Actions, Input, MonthActions } from "@website/ui/datepicker/components";
import styles from "@website/ui/datepicker/components/header/header.module.scss";
import { HeaderPropertiesType } from "@website/ui/datepicker/components/header/header.types";
import { WEEK_ABBR } from "@website/ui/datepicker/constanst";
import { TopAppBar } from "@website/ui/top-app-bar";
import { FC } from "react";
export const Header: FC<HeaderPropertiesType> = properties => {
  const $ = _c(34);
  const {
    calendarLocale: t0,
    showDates,
    inputProperties,
    scrolled,
    onClose,
    showToday,
    changeCalendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled,
    type,
    view,
    backButton
  } = properties;
  const calendarLocale = t0 === undefined ? "gregorian" : t0;
  const t1 = `${styles.header} ${styles["rtl" || "ltr"]} ${scrolled ? styles.scrolled : ""}`;
  let t2;
  if ($[0] !== backButton || $[1] !== onClose || $[2] !== scrolled) {
    t2 = !scrolled && <div className={styles["top-app-bar"]}><TopAppBar StartAction={<Button EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />} color="neutral" equalDimension={true} onClick={() => {
        onClose();
        if (backButton) {
          setTimeout(backButton, 100);
        }
      }} variant="text" />} title={"\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E"} /></div>;
    $[0] = backButton;
    $[1] = onClose;
    $[2] = scrolled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== calendarLocale || $[5] !== changeCalendarLocale || $[6] !== scrolled || $[7] !== showToday) {
    t3 = !scrolled && <Actions calendarLocale={calendarLocale} changeCalendarLocale={changeCalendarLocale} showToday={showToday} />;
    $[4] = calendarLocale;
    $[5] = changeCalendarLocale;
    $[6] = scrolled;
    $[7] = showToday;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== inputProperties) {
    t4 = <div className={styles["input-container"]}><Input {...inputProperties} disabled={true} fullWidth={true} /></div>;
    $[9] = inputProperties;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className={styles["part-one"]}>{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== calendarLocale || $[15] !== nextMonthDisabled || $[16] !== previousMonthDisabled || $[17] !== showDates || $[18] !== showNextMonth || $[19] !== showPreviousMonth || $[20] !== type) {
    t6 = <MonthActions calendarLocale={calendarLocale} nextMonthDisabled={nextMonthDisabled} previousMonthDisabled={previousMonthDisabled} showDates={showDates} showNextMonth={showNextMonth} showPreviousMonth={showPreviousMonth} type={type} />;
    $[14] = calendarLocale;
    $[15] = nextMonthDisabled;
    $[16] = previousMonthDisabled;
    $[17] = showDates;
    $[18] = showNextMonth;
    $[19] = showPreviousMonth;
    $[20] = type;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const t7 = `${styles["week-names-container-mobile"]} ${view === "mobile" ? "" : styles["week-names-container-mobile__default"]}`;
  let t8;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [1, 2, 3, 4, 5, 6, 7];
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== calendarLocale) {
    t9 = t8.map(item => <div className={styles["week-name"]} key={item}>{WEEK_ABBR[calendarLocale]?.[item - 1] || WEEK_ABBR.gregorian[item - 1]}</div>);
    $[23] = calendarLocale;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t9) {
    t10 = <div className={t7}>{t9}</div>;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t1 || $[29] !== t10 || $[30] !== t2 || $[31] !== t5 || $[32] !== t6) {
    t11 = <div className={t1}>{t2}{t5}{t6}{t10}</div>;
    $[28] = t1;
    $[29] = t10;
    $[30] = t2;
    $[31] = t5;
    $[32] = t6;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};